// extracted by mini-css-extract-plugin
module.exports = {"attributeBox":"attribute_attributeBox__2QRl5","attrLink":"attribute_attrLink__2Shad","attrImg":"attribute_attrImg__1ojBJ","title":"attribute_title__2HqR0"};